// extracted by mini-css-extract-plugin
export default {"checkMailWrapper":"checkmail_checkMailWrapper__GSr68","checkMailContainer":"checkmail_checkMailContainer__M4uuQ"};